import { OrganizationType } from 'modules/Common/utils/Utility';

// The home each org type lands on. Shared by OrgBoundary (post-switch
// redirect), InitPage (post-sign-in routing) and PrivateRoute (the org-type
// re-home, docs/adr/0003) so they can never disagree about where an org type
// belongs.
//
// Returns null for an unrecognised type. It deliberately does NOT fall back to
// the operator overview: every home is org-type-gated, so guessing sends a
// declarant to an operator-only route, which the org-type gate then refuses.
// Callers must treat null as "no home for this type — don't navigate".
export const overviewPathForOrgType = (type) => {
  if (type === OrganizationType.Declarant) return '/overview';
  if (type === OrganizationType.Consultant) return '/consultant-overview';
  if (type === OrganizationType.Operator) return '/operator-overview';
  if (type === OrganizationType.Verifier) return '/verifier';
  return null;
};

// The active organization, read from Clerk's authoritative imperative resource
// with the React hook only as a fallback.
//
// `useOrganization()` lags a same-session `setActive()` switch (the reactivity
// gap this whole module exists to work around), and both callers run at exactly
// the moment that lag is in effect. Reading the hook there routed a declarant
// to the previous operator org's overview → /not-found.
export const readActiveOrg = (hookOrganization) =>
  (typeof window !== 'undefined' ? window.Clerk?.organization : null) ?? hookOrganization ?? null;
